import { ExamMarkOmr } from '@/plugins/api'
import alert from '@/plugins/alert'
import axios from '@/plugins/axios'

const UPLOAD_API = '/upload/'
const DESTROY_API = '/upload/files/'
/* eslint-disable no-unused-vars */
export default {
  namespaced: true,
  actions: {
    uploadImage({ commit }, formData) {
      return axios
        .post(UPLOAD_API, formData, { headers: { 'Content-Type': 'multipart/form-data' } })
        .catch(e => alert.error('Tải ảnh thất bại'))
    },
        destroyImage({ commit }, id) {
          return axios
            .delete(DESTROY_API + id)
            .catch(e => alert.error(e))
        },
    async calMore({ commit }, {  ...data }) {
      console.log(data)
      const result = await ExamMarkOmr.calMore({ ...data })
      return result
    },
    async cal({ commit }, { id, ...data }) {
      const result = await ExamMarkOmr.cal(id, { ...data })
      return result
    },
  }
}
/* eslint-disable no-unused-vars */
